module.exports = __webpack_public_path__ + "media/src/images/icon__magazinCheck--dark-4b7c10c92c35012901268c0a10ac9bf5.svg";